import Vue from 'vue';
import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

import AddToBasket from './components/AddToBasket.vue';
import BasketWidget from './components/BasketWidget.vue';
import BasketItems from './components/BasketItems.vue';

Vue.component('add-to-basket', AddToBasket);
Vue.component('basket-widget', BasketWidget);
Vue.component('basket-items', BasketItems);

new Vue({ el: '#app' });

// Waitlist forms — plain JS, delegated so multiple forms on one page work.
// Each form has data-variant and data-context and a sibling .waitlist-message
// element identified by data-for=<form id>.
document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.waitlist-form');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('button[type=submit]');
    const emailInput = form.querySelector('input[name=email]');
    const messageEl = document.querySelector(`.waitlist-message[data-for="${form.id}"]`);
    const variant = form.dataset.variant;
    const context = form.dataset.context || '';

    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding…';
    if (messageEl) {
        messageEl.classList.add('hidden');
        messageEl.textContent = '';
    }

    try {
        const { data } = await window.axios.post('/waitlist', {
            email: emailInput.value.trim(),
            variant,
            source_context: context,
        });
        // Replace the form with the thank-you message
        if (messageEl) {
            messageEl.textContent = data.message || "You're on the list.";
            messageEl.className = 'waitlist-message text-sm mt-3 text-green-700 font-medium';
            messageEl.classList.remove('hidden');
        }
        form.style.display = 'none';
    } catch (err) {
        const msg = err.response?.data?.message
            || err.response?.data?.errors?.email?.[0]
            || "Couldn't sign you up. Check the email and try again.";
        if (messageEl) {
            messageEl.textContent = msg;
            messageEl.className = 'waitlist-message text-sm mt-3 text-red-700';
            messageEl.classList.remove('hidden');
        }
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify me';
    }
});
